import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from "react-redux";
import {compose} from "recompose";
import {RESOURCES as loyaltyResources} from '../fuseLoyaltyResourceMap';
import {convertDateToLocalString} from '../shared/functions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import FuseTheme from "../global/theme";
import {filterCaseInsensitive, setDefaultTableSort} from '../shared/tableFunctions';
import ReactTable from 'react-table';
import ProductUnitsStaticIconButton from '../buttons/ProductUnitsStaticIconButton';

// Create secondary row subcomponent for each row
const listSubcomponent = (row) => {
    const meta = row.original.customer_metadata || {};
    const hasMetadata = meta && Object.keys(meta).length > 0;

    const container = {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '18px 25px',
        background: '#fafafa',
        border: '1px solid #ddd',
        borderRadius: '6px',
        margin: '10px 0',
        gap: '50px',
        fontSize: '14px',
        lineHeight: '20px'
    };

    const sectionTitle = {
        fontWeight: '600',
        fontSize: '15px',
        margin: '0 0 8px 0',
        borderBottom: '1px solid #ccc',
        paddingBottom: '6px',
    };


    const grid = {
        display: 'grid',
        gridTemplateColumns: '120px auto',
        rowGap: '4px'
    };

    return (
        <div style={container}>
            <div style={{ flex: 1 }}>
                <div style={sectionTitle}>Details</div>
                <div style={grid}>
                    <div><strong>System:</strong></div><div>{row.original.system || ""}</div>
                    <div><strong>Loyalty Id:</strong></div><div>{row.original.loyalty_id || ""}</div>
                    <div><strong>Deactivated By:</strong></div><div>{row.original.deactivated_by || ""}</div>
                    <div><strong>Deactivated On:</strong></div><div>{row.original.deactivated_on_local_str || ""}</div>
                </div>
            </div>

            {hasMetadata &&
                <div style={{ flex: 1 }}>
                    <div style={sectionTitle}>Customer Metadata</div>
                    <div style={grid}>
                        {Object.keys(meta).map((key) => (
                            <React.Fragment key={key}>
                                <div><strong>{key}:</strong></div>
                                <div>{meta[key] !== null && meta[key] !== undefined ? meta[key].toString() : ""}</div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            }
        </div>
    );
};



/**
 * A component for generating rows of TagsTableRows for a Loyalty Account.
 *
 */
class TagsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountId: '',
            tagsList: [],
        };
    }

    componentWillMount() {
        this.setState({
            accountId: this.props.accountId,
        });
        this.fetchTransactions();
    }

    // Get all Transactions for this Loyalty Account
    fetchTransactions() {
        const params = {
            filter: {
                account_id: this.props.accountId
            },
        };
        const resource = loyaltyResources.LoyaltyAccountTags.GET_LIST(params);

        // Retrieve the data and store results
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        this.processTransactions(result.data.payload);
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    processTransactions = (list) => {
        let endList = []
        list.forEach(function (item, idx) {
            item.modified_local_str = convertDateToLocalString(item.modified, true);
            item.created_on_local_str = convertDateToLocalString(item.created_on, true);
            item.expires_on_local_str = convertDateToLocalString(item.expires_on, true);
            endList.push(item);
        });
        this.setState({
            tagsList: endList
        });
    };


    render() {
        const {tagsList} = this.state;

        const tableColumns = [
            {
                Header: 'Tag',
                columns: [
                    {
                        Header: 'Name',
                        accessor: 'tag_name',
                    },
                    {
                        Header: 'Title',
                        accessor: 'tag_title',
                    },
                    {
                        Header: 'Display',
                        accessor: 'tag_title_display',
                        Cell: row => (
                            <span>{row.original.tag_title_display ? "YES" : "NO"}</span>
                        ),
                        filterable: false,
                        width: 80
                    },
                    {
                        Header: 'Expires On',
                        accessor: 'expires_on_local_str',
                        filterable: false,
                    },
                    {
                        Header: 'Active',
                        accessor: 'deactivated',
                        Cell: row => (
                            <span>{row.original.deactivated ? "NO" : "YES"}</span>
                        ),
                        filterable: false,
                        width: 80
                    },
                ]
            },
            // {
            //     Header: 'Deactivated By',
            //     accessor: 'deactivated_by',
            //     headerStyle: tableStyles.left
            // },
            // {
            //     Header: 'Deactivated On',
            //     accessor: 'deactivated_on_local_str',
            //     filterable: false,
            //     headerStyle: tableStyles.left
            // },
            {
                Header: 'Created',
                columns: [
                    {
                        Header: 'Created By',
                        accessor: 'created_by',
                    },
                    {
                        Header: 'Created On',
                        accessor: 'created_on_local_str',
                        filterable: false,
                    },
                ]
            },
            {
                Header: 'Modified',
                columns: [
                    {
                        Header: 'Modified By',
                        accessor: 'modified_by',
                    },
                    {
                        Header: 'Modified On',
                        accessor: 'modified_local_str',
                        filterable: false,
                    },
                ]
            },
            {
                Header: 'Details',
                source: '',
                label: '',
                Expander: ({isExpanded}) =>
                    <div>
                        {isExpanded
                            ? <ProductUnitsStaticIconButton/>
                            : <ProductUnitsStaticIconButton/>}
                    </div>,
                expander: true,
                filterable: false,
                sortable: false,
                width: 90
            },
        ];
        const defaultSort = setDefaultTableSort({field: 'created_on', order: 'ASC'});

        const styles = {
            fieldDescription: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            tableCard: {display: 'block', margin: '1em 0 0 0'},
        };

        return (
            <Card style={styles.tableCard} initiallyExpanded>
                <CardHeader title="Tags" actAsExpander={true} showExpandableButton={true}/>
                <CardText expandable={true}>
                    <span style={styles.fieldDescription}>Tags for this Loyalty Account.</span>
                    <ReactTable
                        key="table-list"
                        data={tagsList}
                        columns={tableColumns}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        ref={(r) => this.reactTable = r}
                        resizable={false}
                        minRows={0}
                        className="-striped overflow"
                        SubComponent={listSubcomponent}
                    />
                </CardText>
            </Card>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            accountId: ownProps.accountId,
        }
    }
    return {}
};

TagsTable.propTypes = {
    addField: PropTypes.bool,
    accountId: PropTypes.string,
};

TagsTable.defaultProps = {
    addField: true,
    accountId: null,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(TagsTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/TagsTable.js